import React from "react";
import { useEffect, useContext } from "react";
import SimpleContext from "../context/SimpleContext";
import SimpleSlider from "./SimpleSlider";
import Preloader from "../Preloader/preloader";
import { useHistory } from "react-router";
import config from "../../services/config.json";
import { useState } from "react";
import Preloader3 from "../Preloader/preloader3";
import "./Applications.css";
import { browserName, browserVersion } from "react-device-detect";
const AppPage = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();
  const [applications, setapplications] = useState([]);

  useEffect(() => {
    context.AppType=0
    context.setAppType(context.AppType)
    getApptype();
  }, []);

  //وب سرویس برای گرفتن اپ تایپ
  const getApptype = () => {
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${context.baseUrlApiPakhsh}${config.applicationList}`;
      const formData = new FormData();
      formData.append(
        "customerId",
        Object.values(context.UseInFo).length > 0 && context.UseInFo.customerId
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", context.UniqueUUID);
      formData.append("appTypeId", context.AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            context.setmodalPopUp(true);
            context.setTextPopUp(data.popUp);
          }
        } else {
          context.setmodalPopUp(false);
        }

        if (data.code === 200) {
          if (data.response.length > 0) {
            let res = data.response;
            if (data.response.length === 1) {
              history.push("/homePage");
              context.setAppType(data.response[0].id);
            } else {
              setapplications(data.response);
            }
          } else {
            context.Handelerror("خطایی رخ داده است !");
          }
        } else if (data.code === 400) {
          context.Handelerror(data.message);
        } else {
          context.Handelerror(data.message);
        }
      });
    } catch (ex) {
      context.HandelShowContentPage("3");
      console.log(ex);
    }
  };
  const goToHomePage = (i) => {
    if (i.status === true) {
      context.setAppType(i.id);
      history.push("/homePage");
    } else {
      context.handleError(i.closeMessage);
    }
  };
  return (
    <>
      <div className="applicationList">
        {applications.length > 0 ? (
          applications.length > 1 ? (
            applications.map((i) =>
              i.imageLink !== "" ? (
                <div>
                  <img onClick={() => goToHomePage(i)} src={i.imageLink} />
                  <div className="countRowBasketApp">
                    <img src="/images/Basket1.png" />
                    <span>{i.countRowBasket}</span>
                  </div>
                </div>
              ) : (
                <div>
                  <img
                    onClick={() => goToHomePage(i)}
                    src="/images/placeholder.jpg"
                  />
                  <div className="countRowBasketApp">
                    <img src="/images/Basket1.png" />
                    <span>{i.countRowBasket}</span>
                  </div>
                </div>
              )
            )
          ) : (
            <Preloader3 />
          )
        ) : (
          <Preloader3 />
        )}
      </div>
      <div onClick={()=>history.push("/userPonits")} className="fixedImages">
        {
          Object.values(context.festivalData).length>0&&
          <>
        <span>{context.festivalData.pointSumValue}</span>
        <img  src={context.festivalData.img} />
          </>
        }
      </div>
    </>
  );
};

export default AppPage;
